/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import type { FC } from "react";
import { Link } from "./Link";

interface Props {
  className?: string;
}


export const IG: FC<Props> = ({ className }: Props) => {
  return (
    <Link
      href="https://www.instagram.com/staffmartialart/"
      aria-label="Follow staffmartialart on Instagram"
      target="_blank"
      rel="noreferrer"
    >
      <svg id="ig"
        className={`${className}`}
        aria-hidden="true"
        fill="none"
        height="33"
        viewBox="0 0 34 33"
        width="34"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.3465 9.08794C13.2473 9.08794 9.9408 12.3944 9.9408 16.4936C9.9408 20.5928 13.2473 23.8993 17.3465 23.8993C21.4457 23.8993 24.7521 20.5928 24.7521 16.4936C24.7521 12.3944 21.4457 9.08794 17.3465 9.08794ZM17.3465 21.3083C14.6974 21.3083 12.5318 19.1491 12.5318 16.4936C12.5318 13.8381 14.691 11.679 17.3465 11.679C20.0019 11.679 22.1611 13.8381 22.1611 16.4936C22.1611 19.1491 19.9955 21.3083 17.3465 21.3083ZM26.7824 8.78501C26.7824 9.74536 26.009 10.5124 25.0551 10.5124C24.0947 10.5124 23.3277 9.73892 23.3277 8.78501C23.3277 7.8311 24.1012 7.05767 25.0551 7.05767C26.009 7.05767 26.7824 7.8311 26.7824 8.78501ZM31.6873 10.5381C31.5777 8.22427 31.0492 6.17466 29.3541 4.48599C27.6654 2.79731 25.6158 2.2688 23.3019 2.15278C20.9172 2.01743 13.7693 2.01743 11.3846 2.15278C9.07713 2.26235 7.02752 2.79087 5.33241 4.47954C3.63729 6.16821 3.11522 8.21782 2.9992 10.5317C2.86385 12.9165 2.86385 20.0643 2.9992 22.4491C3.10877 24.7629 3.63729 26.8125 5.33241 28.5012C7.02752 30.1899 9.07069 30.7184 11.3846 30.8344C13.7693 30.9698 20.9172 30.9698 23.3019 30.8344C25.6158 30.7249 27.6654 30.1963 29.3541 28.5012C31.0428 26.8125 31.5713 24.7629 31.6873 22.4491C31.8226 20.0643 31.8226 12.9229 31.6873 10.5381ZM28.6064 25.0079C28.1037 26.2711 27.1305 27.2444 25.8607 27.7536C23.9594 28.5077 19.4476 28.3336 17.3465 28.3336C15.2453 28.3336 10.7271 28.5012 8.83221 27.7536C7.56893 27.2508 6.59569 26.2776 6.08651 25.0079C5.33241 23.1065 5.50643 18.5948 5.50643 16.4936C5.50643 14.3924 5.33885 9.87427 6.08651 7.97935C6.58924 6.71606 7.56248 5.74282 8.83221 5.23364C10.7336 4.47954 15.2453 4.65356 17.3465 4.65356C19.4476 4.65356 23.9658 4.48599 25.8607 5.23364C27.124 5.73638 28.0972 6.70962 28.6064 7.97935C29.3605 9.88071 29.1865 14.3924 29.1865 16.4936C29.1865 18.5948 29.3605 23.1129 28.6064 25.0079Z"
          fill="white"
        />
      </svg>
    </Link>
  );
};
